export default function setStickyBuy() {
  const sticky = document.querySelector('[data-rd-pdp-sticky]');
  const buyBox = document.querySelector('[data-rd-pdp-buy]');
  const form = document.querySelector('[data-section-product] [data-product-purchase]');

  if (!sticky || !form) return;

  const root = document.body;
  const addBtn = form.querySelector('[data-action="add-cart"]');
  const stickyAdd = sticky.querySelector('[data-rd-sticky-add]');
  const stickyPrice = sticky.querySelector('[data-rd-sticky-price]');
  const mainPrice = buyBox ? buyBox.querySelector('[data-init-price], .product-price') : null;

  // Sticky sempre visível
  sticky.classList.add('is-visible');
  sticky.setAttribute('aria-hidden', 'false');
  root.classList.add('rd-pdp-sticky-active');

  const stickyCtaText = sticky.querySelector('.rd-pdp-sticky__cta-text');

  const syncPrice = () => {
    if (!stickyPrice || !mainPrice) return;
    // Evita copiar o rótulo "Esgotado" do cmp-price junto com o valor.
    const priceOnly = mainPrice.querySelector('.cmp-price-price, .cmp-price-sale-price');
    const text = (priceOnly || mainPrice).textContent.replace(/\s+/g, ' ').trim();
    if (text) stickyPrice.textContent = text;
  };

  const syncAvailability = () => {
    if (!stickyAdd) return;

    const unavailable = Boolean(addBtn && addBtn.classList.contains('-unavailable'));
    sticky.classList.toggle('is-sold-out', unavailable);
    stickyAdd.classList.toggle('is-sold-out', unavailable);
    stickyAdd.toggleAttribute('disabled', unavailable);
    stickyAdd.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

    if (stickyPrice) stickyPrice.hidden = unavailable;
    if (stickyCtaText) {
      stickyCtaText.textContent = unavailable ? 'Esgotado' : 'Adicionar ao carrinho';
    }

    if (!unavailable) syncPrice();
  };

  // Elementos sticky
  const weightField = sticky.querySelector('[data-rd-sticky-select="weight"]');
  const grindField = sticky.querySelector('[data-rd-sticky-select="grind"]');
  const stickyQtyValue = sticky.querySelector('[data-rd-sticky-qty]');
  const stickyMinus = sticky.querySelector('[data-rd-sticky-minus]');
  const stickyPlus = sticky.querySelector('[data-rd-sticky-plus]');

  // Campos principais (hidden)
  const mainSelects = form.querySelectorAll('[data-custom-select] select');
  const mainQtyInput = form.querySelector('input[name="quantity"]');
  const mainQtyMinus = form.querySelector('[data-qtd-minus]');
  const mainQtyPlus = form.querySelector('[data-qtd-plus]');

  // Criar dropdowns customizados
  const createDropdown = (field, selectIndex) => {
    const select = mainSelects[selectIndex];
    if (!select) return;

    const wrapper = field.closest('.rd-pdp-sticky__field-wrapper');
    let dropdown = wrapper.querySelector('.rd-pdp-sticky__dropdown');

    if (!dropdown) {
      dropdown = document.createElement('div');
      dropdown.className = 'rd-pdp-sticky__dropdown';
      wrapper.appendChild(dropdown);
    }

    // Limpar e popular opções
    dropdown.innerHTML = '';
    Array.from(select.options).forEach((option) => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'rd-pdp-sticky__dropdown-item';
      item.textContent = option.text;
      item.dataset.value = option.value;

      if (option.selected) {
        item.classList.add('is-selected');
      }

      item.addEventListener('click', (e) => {
        e.stopPropagation();
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        closeAllDropdowns();
        syncValues();
      });

      dropdown.appendChild(item);
    });

    return dropdown;
  };

  const closeAllDropdowns = () => {
    document.querySelectorAll('.rd-pdp-sticky__field').forEach((f) => {
      f.classList.remove('is-open');
    });
    document.querySelectorAll('.rd-pdp-sticky__dropdown').forEach((d) => {
      d.classList.remove('is-open');
    });
  };

  const toggleDropdown = (field, selectIndex) => {
    const isOpen = field.classList.contains('is-open');
    closeAllDropdowns();

    if (!isOpen) {
      const dropdown = createDropdown(field, selectIndex);
      field.classList.add('is-open');
      dropdown.classList.add('is-open');
    }
  };

  // Sincronizar valores dos selects para os labels
  const syncValues = () => {
    if (mainSelects.length > 0 && weightField) {
      const weightSelect = mainSelects[0];
      const weightValue = weightSelect.options[weightSelect.selectedIndex]?.text || '250g';
      weightField.querySelector('[data-rd-sticky-weight]').textContent = weightValue;
    }

    if (mainSelects.length > 1 && grindField) {
      const grindSelect = mainSelects[1];
      const grindValue = grindSelect.options[grindSelect.selectedIndex]?.text || 'Grãos';
      grindField.querySelector('[data-rd-sticky-grind]').textContent = grindValue;
    }

    if (mainQtyInput && stickyQtyValue) {
      stickyQtyValue.textContent = mainQtyInput.value;
    }
  };

  // Click nos campos: abre dropdown
  if (weightField && mainSelects[0]) {
    weightField.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleDropdown(weightField, 0);
    });
  }

  if (grindField && mainSelects[1]) {
    grindField.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleDropdown(grindField, 1);
    });
  }

  // Fechar dropdowns ao clicar fora
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.rd-pdp-sticky__field-wrapper')) {
      closeAllDropdowns();
    }
  });

  // Quantidade: sincroniza com os botões principais
  if (stickyMinus && mainQtyMinus) {
    stickyMinus.addEventListener('click', (e) => {
      e.preventDefault();
      mainQtyMinus.click();
      if (mainQtyInput) stickyQtyValue.textContent = mainQtyInput.value;
    });
  }

  if (stickyPlus && mainQtyPlus) {
    stickyPlus.addEventListener('click', (e) => {
      e.preventDefault();
      mainQtyPlus.click();
      if (mainQtyInput) stickyQtyValue.textContent = mainQtyInput.value;
    });
  }

  // Adicionar ao carrinho
  if (stickyAdd && addBtn) {
    stickyAdd.addEventListener('click', (event) => {
      event.preventDefault();
      if (addBtn.classList.contains('-unavailable') || stickyAdd.classList.contains('is-sold-out')) {
        return;
      }
      addBtn.click();
    });
  }

  // Observer para mudanças nos selects principais
  mainSelects.forEach((select) => {
    select.addEventListener('change', () => {
      syncValues();
      window.setTimeout(syncAvailability, 50);
    });
  });

  if (mainQtyInput) {
    mainQtyInput.addEventListener('input', () => {
      if (stickyQtyValue) stickyQtyValue.textContent = mainQtyInput.value;
    });
  }

  syncPrice();
  syncValues();
  syncAvailability();

  if (mainPrice) {
    const priceObserver = new MutationObserver(() => {
      syncPrice();
      syncAvailability();
    });
    priceObserver.observe(mainPrice, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (addBtn) {
    const availabilityObserver = new MutationObserver(syncAvailability);
    availabilityObserver.observe(addBtn, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
  }

  form.addEventListener('vnda:sku-change', () => {
    window.setTimeout(() => {
      syncPrice();
      syncValues();
      syncAvailability();
    }, 50);
  });
}
